import UserApi, { UserBasic } from '../../../lib/functions/user'
import { createBasicByCodeCache } from './basicByCodeCache'

// ユーザーコードから UserBasic（氏名・アイコン URL）を引くキャッシュ。
// キャッシュ・重複排除・失敗の扱いは createBasicByCodeCache 側に集約している。
//
// 取得は組織全体のユーザーを対象にした GET /api/v1/users/basic で、プロジェクトの選択状態に
// 依存しない。応答本文には会話中のプロジェクト外のユーザー（他プロジェクトの担当者など）が
// 現れうるため、プロジェクトメンバーの一覧からは引かない。
export const userBasicCache = createBasicByCodeCache<UserBasic>(
  code => UserApi.getBasicByCode(code),
  'user basic'
)
